export default __webpack_public_path__ + "static/media/collabland-case-logo.c4520368.png";